import getColorFromSurfaceVariables from 'src/js/modules/website-design/helpers/get-color-from-surface-variables';
import TAG_NAME_TO_COLOR_VARIABLE from '../constants/tag-name-to-color-variable';

const getPredefinedColorsForBlock = (surfaceId, tagName, variables) => {
  // There is we get predefined colors from the colors variable
  // As we don't have access to :root rule of the template from the editor
  // at first we get a name of the CSS variables and after that get the value of that
  const highEmphasisColor = getColorFromSurfaceVariables(surfaceId, 'text_color', variables);
  const mediumEmphasisOpacity = getColorFromSurfaceVariables(
    surfaceId,
    'text_medium_emphasis_color_opacity',
    variables
  );
  const primaryEmphasisColor = getColorFromSurfaceVariables(
    surfaceId,
    'primary_button_1_background_color',
    variables
  );
  const typographyColor = getColorFromSurfaceVariables(
    surfaceId,
    TAG_NAME_TO_COLOR_VARIABLE[tagName],
    variables
  );

  const highEmphasisHSL = `hsl(${highEmphasisColor})`;
  const mediumEmphasisHSLA = `hsla(${highEmphasisColor}, ${mediumEmphasisOpacity})`;
  const primaryEmphasisHSL = `hsl(${primaryEmphasisColor})`;
  const typographyHSL = `hsl(${typographyColor})`;

  return [
    { value: highEmphasisHSL },
    { value: mediumEmphasisHSLA },
    { value: primaryEmphasisHSL },
    highEmphasisHSL !== typographyHSL && { value: typographyHSL },
  ].filter(Boolean);
};

export default getPredefinedColorsForBlock;
